import { render, staticRenderFns } from "./CoSlider.vue?vue&type=template&id=eab64a00&scoped=true&"
import script from "./CoSlider.vue?vue&type=script&lang=ts&"
export * from "./CoSlider.vue?vue&type=script&lang=ts&"
import style0 from "./CoSlider.vue?vue&type=style&index=0&id=eab64a00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab64a00",
  null
  
)

export default component.exports